<template>
  <div class="google-sign-in-section">
    <div class="google-sign-in-block">
      <h3>Sign In to your account</h3>
      <p class="">Google Users must provide account authorization to complete the Nylas / Call Steward Calendar Integration.</p>
      <div class="mt-20">
        <div class="form-group">
          <div class="clearfix signin_options">
              <!-- <a href="javascript: void(0)" v-google-signin-button="clientId" class="sign-in-google"> -->
              <a href="javascript: void(0)" @click="generateNylasLink" class="sign-in-google">
                  <div class="image-block">
                      <img src="static/assets/images/Google-512.webp" />
                  </div>
                  <div class="button-font">
                      <span>
                      Sign in  with Google
                      </span>
                  </div>
              </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import service from '../services.js';
import { mapGetters } from 'vuex';
export default {
  data(){
    return{
      clientId: "508718336686-s1b3dg4trrs2fk287qsegbregbthkiuu.apps.googleusercontent.com"
    };
  },
  computed: {
    ...mapGetters({
        userToken: 'userToken',
        userID: 'userID',
        getNylasUserEmail: 'getNylasUserEmail'
    })
  },
  mounted() {},
  created(){},
  methods: {
    OnGoogleAuthSuccess (idToken) {
      // Receive the idToken and make your magic with the backend
      // console.log(idToken); 
      if(idToken) {
        this.generateNylasLink()
      }else {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong!'
        })
      }
    },

    OnGoogleAuthFail (err) {
      this.$notify.error({
          title: 'Error',
          message: err.error
      });
    },

    generateNylasLink() {
      service.get('employee/authorizeNylas', {
          'Authorization': this.userToken,
          'user-id': this.userID,
          'email': this.getNylasUserEmail
      }).then((res) => {
        if(res.data&&res.data.result) {          
          window.location.href = res.data.result;
          this.$notify({
            type: 'success',
            title: this.$t('success'),
            message: 'Nylas Subscription Started. Thank you for being with us!'
          });          
        }        
      }).catch((err) => {
          console.log(err);
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong!'
          });
      });
    }
  }
}
</script>

<style scoped>

  .mt-10 {
    margin-top: 10px;
  }
  .mt-20 {
    margin-top: 20px;
  }
  .google-sign-in-section {
    width: 100%;
    margin: 80px 0 auto;
  }
  .google-sign-in-section .google-sign-in-block {
    padding: 30px;
    border-radius: 10px;
    border: solid 1px #222222;
    line-height: 2;
    margin: 30px auto;
    width: 500px;
    font-size:16px;
    background-color: #fefefe;
  }

  @media (min-width:0px) and (max-width:767px) {
    .google-sign-in-section .google-sign-in-block {
      line-height: 2;
      margin: 30px!important;
      width:100%;
      font-size:16px;
      background-color: #fefefe;
    }
  }

  /* @media (min-width:768px) and (max-width:2400) {
    .google-sign-in-section .google-sign-in-block {
      padding: 40px;
      margin: 30px auto;
      width: 400px;
    }
  } */
  
  .signin_options {        
      /* display: flex;
      flex-direction: column;
      justify-content: center; */
  }

  .login-center {
      left: 60%;
  }

  .signin_options .sign-in-google {
      display: flex;
      flex-direction: row;
      justify-items: center;
      width: 200px;
      height: 36px;
      border-radius: 2px;
      padding: 1px;
      background-color: #4285F4;
  }

  .signin_options .sign-in-google .image-block {
    height: 34px;
    width: 34px;
    background-color: #ffffff;
    text-align: center;
    vertical-align: middle;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 5px;
  }


  .signin_options .sign-in-google .image-block img {
      background-color: #FFFFFF;
      height: 24px;
      width: 24px;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
  }

  /* .signin_options .sign-in-google .button-font{
      margin-top: 10px;
  } */

  .signin_options .sign-in-google .button-font span {
      color: #FFFFFF;
      font-size: 16px;
      vertical-align: middle;
      padding: 10px;
      font-weight: 500;
      font-family: 'Roboto', 'Helvetica';
  }

</style>